

























































































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import PicModal from '@/components/upload/picModal.vue'
import draggable from 'vuedraggable'
import Swiper from './components/swiper.vue'
import Products from './components/products.vue'
import Pictures from './components/pictures.vue'
import HomeSetApi from '@/api/shopMall/pcMallDecorate/homeSet/index'
@Component({
  components: {
    PicModal,
    draggable,
    Swiper,
    Products,
    Pictures,
  },
})
export default class PcHomeSetting extends AbpBase {
  couponList: any[] = []
  isShowContentLeft: boolean = true
  isShowContentRight: boolean = true
  isShowStartTime: any = false
  maxNumberApp: number = 1
  isHome: boolean = false
  MallDiyConfig = {
    isHome: false,
    isActive: false,
    name: '',
    startTime: null,
    endTime: null,
    pcHomeDiyPages: [],
  }

  // 当前选择的组件
  selectIndex = -1

  showDemoIndex = -1

  ruleMallDiy = {
    name: [{ required: true, message: '请输入微页面名称', trigger: 'blur' }],
  }

  get selectForm() {
    if (this.selectIndex < 0) {
      return {}
    } else {
      return this.MallDiyConfig.pcHomeDiyPages[this.selectIndex]
    }
  }

  componentList = [
    {
      img: require('@/assets/images/banner.png'),
      label: '轮播图',
      type: 'swiper',
    },
    {
      img: require('@/assets/images/rubik.png'),
      label: '图片分类',
      type: 'pictures',
    },
    {
      img: require('@/assets/images/goods.png'),
      label: '商品列表',
      type: 'products',
    },
  ]

  mounted() {
    this.getConfig()
    this.isShowStartTime = this.$route.query['isHomePage']
  }
  handleBack() {
    this.$router.go(-1)
  }
  handleGetStrartTime(date) {
    console.log(date);
    this.MallDiyConfig.startTime = date
  }
  handleGetEndTime(date) {
    this.MallDiyConfig.endTime = date
  }
  /**
   * 获取开启时间
   */
  handleGetstartTime(date) {
    console.log(date)
    this.MallDiyConfig.startTime = date
  }
  /**
   * 获取设置
   */
  getConfig() {
    let id = this.$route.query['id']
    this.isHome = Boolean(this.$route.query['isHome'])
    if (id) {
      HomeSetApi.getPCHomeTemplateDetail(id.toString()).then((res) => {
        console.log('首页模板详情', res)
        if (res.data) {
          console.log(res.data)
          res.data.pcHomeDiyPages.forEach(item => {
            if(item.componentType == 0 && item.photosComponent.displayType == 1) {
              item.type = 'swiper'
            }else if(item.componentType == 0 && item.photosComponent.displayType == 0) {
              item.type = 'pictures'
              item.styleType = item.photosComponent.displayMode
            }else if(item.componentType == 1) {
              item.type = 'products'
            }
          })
          console.log('修改后的', res.data);
          this.MallDiyConfig = res.data
        }
      })
    }
  }

  numberChange(value) {
    this.maxNumberApp = value
  }
  selectCouponList(value) {
    this.couponList = value
    this.maxNumberApp = value.length
    console.log(this.couponList)
  }
  /**
   * 保存
   */
  submit() {
    let vm = this
    let mallDiyForm: any = vm.$refs.mallDiyForm
    if (!this.MallDiyConfig.name && this.MallDiyConfig.name.trim() == '') {
      this.$Message.warning('请输入页面名称')
      return
    }
    mallDiyForm.validate((valid) => {
      if (valid) {
        console.log(this.MallDiyConfig)
        if (this.MallDiyConfig.pcHomeDiyPages && this.MallDiyConfig.pcHomeDiyPages.length > 0) {
          this.MallDiyConfig.pcHomeDiyPages.forEach((item, index) => {
            item.displayOrder = index
          })
          let id = this.$route.query['id']
          if (id) {
            HomeSetApi.updatePCHomeTemplate(id.toString(), this.MallDiyConfig).then((res) => {
              console.log('修改成功', res)
              vm.$Notice.success({
                desc: '提交成功',
              })
              this.$router.go(-1)
            })
          } else {
            HomeSetApi.createPCHomeTemplate(this.MallDiyConfig).then((res) => {
              console.log('提交成功', res)
              vm.$Notice.success({
                desc: '提交成功',
              })
              this.$router.go(-1)
            })
          }
        } else {
          this.$Modal.error({
            title: '请选择组件',
          })
        }
      }
    })
  }

  /**
   * 添加组件
   */
  gridClick(item) {
    let obj = {}
    switch (item.type) {
      case 'swiper':
        obj = {
          type: 'swiper',
          // interval: 3000,
          name: '轮播组件',
          displayOrder: '',
          isActive: true,
          backgroundType: 0,
          backgroundUrl: null,
          isDisplayName: false,
          // 0多图组件/1商品列表/2营销活动
          componentType: 0,
          // 图片组件数据
          photosComponent: {
            displayType: 1,
            displayMode: 0,
            photoItems: [
              {
                displayOrder: 0,
                linkUrl: null,
                photoUrl: null,
              },
            ],
          },
          // 商品组件数据
          productsComponent: {
            productItems: [],
          },
          // 活动组件
          activitiesComponent: {
            activityItems: [],
          },
        }
        break
      case 'products':
        obj = {
          type: 'products',
          maxNumber: 4,
          name: '商品列表',
          displayOrder: '',
          isActive: true,
          backgroundType: 0,
          backgroundUrl: null,
          isDisplayName: false,
          // 0多图组件/1商品列表/2营销活动
          componentType: 1,
          // 图片组件数据
          photosComponent: {
            // 0表示图片 1表示轮播
            displayType: 0,
            displayMode: null,
            photoItems: [],
          },
          // 商品组件数据
          productsComponent: {
            productItems: [],
          },
          // 活动组件
          activitiesComponent: {
            activityItems: [],
          },
        }
        break
      case 'pictures':
        obj = {
          type: 'pictures',
          styleType: 0,
          name: '多图组件',
          displayOrder: '',
          isActive: true,
          backgroundType: 0,
          backgroundUrl: null,
          isDisplayName: false,
          // 0多图组件/1商品列表/2营销活动
          componentType: 0,
          // 图片组件数据
          photosComponent: {
            // 0表示图片 1表示轮播
            displayType: 0,
            displayMode: 0,
            photoItems: [
              {
                displayOrder: 0,
                linkUrl: null,
                photoUrl: null,
              },
            ],
          },
          // 商品组件数据
          productsComponent: {
            productItems: [],
          },
          // 活动组件
          activitiesComponent: {
            activityItems: [],
          },
        }
        break
    }

    if (obj['type']) {
      if(this.selectIndex > -1) {
        this.MallDiyConfig.pcHomeDiyPages.splice(this.selectIndex + 1, 0, obj)
        this.selectIndex = this.selectIndex + 1
      }else {
        this.MallDiyConfig.pcHomeDiyPages.push(obj)
        this.selectIndex = this.MallDiyConfig.pcHomeDiyPages.length - 1
      }
      this.isShowContentRight = true
    }
  }

  /**
   * 选择组件
   */
  selectFn(index) {
    this.selectIndex = index
    this.isShowContentRight = true
  }

  /**
   * 删除组件
   */
  deleteItem(index) {
    this.$Modal.confirm({
      title: '提示',
      content: `确定删除该组件?`,
      onOk: () => {
        this.MallDiyConfig.pcHomeDiyPages.splice(index, 1)
        this.selectIndex = -1
      },
    })
  }

  /**
   * 拖拽事件
   */
  draggableChange(e) {
    console.log(e)
  }

  /**
   * 鼠标移入/移出事件
   */
  onMouseFn(index?) {
    this.showDemoIndex = index
  }
}
